module.exports = __webpack_public_path__ + "static/media/bite-cover.9b984450.jpg";